<!-- @format -->

<ng-container *transloco="let t">
  @if (thesisObs$ | async; as thesis) {
    @if (thesis && thesis.length > 0) {
      <h3>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.HEADINGS.THESIS_DETAILS") }}</h3>
      <dl>
        <div class="form-group-mimic" role="listitem">
          <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.THESIS_NAME") }}</dt>
          <dd>{{ (thesis[0]?.title | localizedString) ?? "-" }}</dd>
        </div>
        <div class="form-group-mimic" role="listitem">
          <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.THESIS_TYPE") }}</dt>
          <dd>{{ (thesis[0]?.thesisTypeUrn | codeLocalizedName | async) ?? "-" }}</dd>
        </div>
        <div class="form-group-mimic" role="listitem">
          <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.THESIS_SUBJECT") }}</dt>
          <dd>{{ (thesis[0]?.subject | localizedString) ?? "-" }}</dd>
        </div>
        <div class="form-group-mimic" role="listitem">
          <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.THESIS_PUBLIC_INSPECTION_DATE") }}</dt>
          <dd>{{ (thesis[0]?.publicInspectionDate | localDateFormat) ? (thesis[0]?.publicInspectionDate | localDateFormat) : "-" }}</dd>
        </div>
        <div class="form-group-mimic" role="listitem">
          <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.THESIS_RESPONSIBILITY_PERSONS") }}</dt>
          @if (thesis[0].responsibilityInfos) {
            <dd>
              @for (responsibilityInfo of thesis[0].responsibilityInfos; track responsibilityInfo) {
                <sis-responsibility-info [responsibilityInfo]="responsibilityInfo"> </sis-responsibility-info>
              }
            </dd>
          } @else {
            <dd> - </dd>
          }
        </div>
        <div class="form-group-mimic" role="listitem">
          <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.THESIS_RESPONSIBLE_ORGANISATIONS") }}</dt>
          @if (thesis[0].organisations | hasOrganisationRole: "urn:code:organisation-role:responsible-organisation") {
            <dd>
              <sis-organisation-role-share
                [hideLabel]="true"
                [organisations]="thesis[0].organisations"
                [organisationRoleUrn]="'urn:code:organisation-role:responsible-organisation'">
              </sis-organisation-role-share>
            </dd>
          } @else {
            <dd> - </dd>
          }
        </div>
      </dl>
    }
  }
</ng-container>
